// Reference responsive breakpoints in Bootstrap docs:
// https://getbootstrap.com/docs/4.3/layout/overview/#responsive-breakpoints
//
// Our breakpoint for selecting between desktop vs mobile is large devices
// i.e. corresponds to `media-breakpoint-down(md)`
export const downMdMql = window.matchMedia('(max-width: 991.98px)')
export const downSmMql = window.matchMedia('(max-width: 767.98px)')
export const downXsMql = window.matchMedia('(max-width: 575.98px)')

/**
 * Use this mixin on components which render either the DesktopHeder or the MobileHeader.
 *
 * `isDesktopMode` returns true for devices having width > 992px
 * `isMobileMode` returns true for devices having width < 768px
 *
 * These variables are mutually exclusive.
 */
export default {
  data() {
    return {
      downMdMqlMatches: downMdMql.matches,
      downSmMqlMatches: downSmMql.matches,
      downXsMqlMatches: downXsMql.matches
    }
  },
  computed: {
    /**
     * returns true on Screen width > 992px
     * @returns {boolean}
     */
    isDesktopMode() {
      return !this.downMdMqlMatches
    },
    /**
     * returns true on Screen width < 768px
     * @returns {boolean}
     */
    isMobileMode() {
      return this.downSmMqlMatches
    },
    /**
     * returns true on Screen width < 576px
     * @returns {boolean}
     */
    isXS() {
      return this.downXsMqlMatches
    }
  },
  methods: {
    onDownMdMqlChange() {
      this.downMdMqlMatches = downMdMql.matches
    },
    onDownSmMqlChange() {
      this.downSmMqlMatches = downSmMql.matches
    },
    onDownXsMqlChange() {
      this.downXsMqlMatches = downXsMql.matches
    }
  },
  mounted() {
    if ('addEventListener' in downMdMql) {
      downMdMql.addEventListener('change', this.onDownMdMqlChange)
      downSmMql.addEventListener('change', this.onDownSmMqlChange)
      downXsMql.addEventListener('change', this.onDownXsMqlChange)
    } else if ('addListener' in downMdMql) {
      downMdMql.addListener(this.onDownMdMqlChange)
      downSmMql.addListener(this.onDownSmMqlChange)
      downXsMql.addListener(this.onDownXsMqlChange)
    }
  },
  beforeDestroy() {
    if ('removeEventListener' in downMdMql) {
      downMdMql.removeEventListener('change', this.onDownMdMqlChange)
      downSmMql.removeEventListener('change', this.onDownSmMqlChange)
      downXsMql.removeEventListener('change', this.onDownXsMqlChange)
    } else if ('removeListener' in downMdMql) {
      downMdMql.removeListener(this.onDownMdMqlChange)
      downSmMql.removeListener(this.onDownSmMqlChange)
      downXsMql.removeListener(this.onDownXsMqlChange)
    }
  }
}
